"use strict";
import date_format from "date-and-time";
import i18n from "@/lang";
export default {
  // 你永远不知道服务端会给你秒级还是毫秒级
  check: (time) => {
    const _time = String(time);
    if (_time.length > 10) {
      return time;
    }
    time = time * 1e3;
    return time;
  },
  // 将毫秒级时间戳降级为秒级时间戳 相信我 会用到的
  ToSecond: (time) => {
    const _time = String(time);
    if (_time.length > 10) {
      return Math.floor(time / 1e3);
    }
    return time;
  },
  date: (time) => {
    const date = new Date();
    date.setTime(time);
    return date.toLocaleDateString();
  },
  dateTime: (time) => {
    const date = new Date();
    date.setTime(time);
    return date.toLocaleString();
  },
  last: (time) => {
    return {
      day: () => {
        return Math.ceil(time / 86400);
      }
    };
  },
  dateformatterDay: (time) => {
    return date_format.format(new Date(time), "YYYY-MM-DD");
  },
  dateformat: (time) => {
    return date_format.format(new Date(time), "YYYY/MM/DD HH:mm:ss");
  },
  dateformatMin: (time) => {
    return date_format.format(new Date(time), "YYYY/MM/DD HH:mm");
  },
  dateformatterMin: (time) => {
    return date_format.format(new Date(time), "YYYY-MM-DD HH:mm");
  },
  dateformatter: (time) => {
    return date_format.format(new Date(time), "YYYY-MM-DD HH:mm:ss");
  },
  dateformatDay: (time) => {
    return date_format.format(new Date(time), "YYYY/MM/DD");
  },
  format_open_date: (time) => {
    let target = new Date(time);
    let target_y = target.getFullYear();
    let target_m = target.getMonth() + 1;
    let target_d = target.getDate();
    let date_target = target_y + "-" + target_m + "-" + target_d;
    let now = new Date();
    let y = now.getFullYear();
    let m = now.getMonth() + 1;
    let d = now.getDate();
    let date = y + "-" + m + "-" + d;
    if (date_target === date) {
      return date_format.format(new Date(time), "HH:mm");
    } else {
      return date_format.format(new Date(time), "MM-DD HH:mm");
    }
    return time;
  },
  format_login_time: (time) => {
    let _time = Date.now() - time;
    if (_time < 6e4) {
      return i18n.t("timefomatter.seconds_ago");
    }
    if (_time < 36e5) {
      _time = Math.floor(_time / (1e3 * 60));
      return i18n.t("timefomatter.minites_ago", { time: _time });
    }
    if (_time < 864e5) {
      _time = Math.floor(_time / (1e3 * 60 * 60));
      return i18n.t("timefomatter.hours_ago", { time: _time });
    }
    if (i18n.locale === "zh-CN") {
      return date_format.format(new Date(time), "YYYY-M-DD HH:mm");
    }
    if (i18n.locale !== "zh-CN") {
      return date_format.format(new Date(time), "DD.MM.YYYY HH:mm");
    }
    return date_format.format(new Date(time), "MMM DD,YYYY");
  },
  format_expire_time: (time) => {
    let target = new Date(time);
    let target_year = target.getFullYear();
    let now_year = new Date().getFullYear();
    if (now_year !== target_year) {
      return date_format.format(target, "YY-MM-DD");
    } else {
      return date_format.format(target, "MM-DD");
    }
  },
  format_expire_detail_time: (time) => {
    let target = new Date(time);
    return date_format.format(target, "YYYY-MM-DD");
  }
};
